export default __webpack_public_path__ + "static/media/ms_logo1.e5e12880.png";